export enum LegalType {
    None,
    EULA,
    TermsandCondition,
    OpenSource,
    HighCharts,
    ReactJs,
}

export type EulaPayload = {
    status: number;
    data: string;
};
